import { PackageNamespace } from '@tablekit/package-namespace';
var baseDefaultWidth = 360;
var defaultMaxWidth = 1000;
var baseDefaultHeight = 360;
var defaultMaxHeight = '100vh';
var panelThemeNamespace = PackageNamespace.Panel;
var panelClassicTheme = {
  backgroundColor: function backgroundColor(_ref) {
    var theme = _ref.theme;
    return theme.colors.surface;
  },
  borderColor: function borderColor(_ref2) {
    var theme = _ref2.theme;
    return theme.colors.border;
  },
  borderColorHover: function borderColorHover(_ref3) {
    var theme = _ref3.theme;
    return theme.colors.primary;
  }
};
var panelDarkTheme = panelClassicTheme;
export { baseDefaultHeight, baseDefaultWidth, defaultMaxHeight, defaultMaxWidth, panelClassicTheme, panelDarkTheme, panelThemeNamespace };
